import React, { useState, useEffect, useRef } from "react";
import {
	IonButton,
	IonCheckbox,
	IonCol,
	IonIcon,
	IonInput,
	IonItem,
	IonLabel,
	IonModal,
	IonRadio,
	IonRadioGroup,
	IonRow,
	IonText,
	isPlatform,
	IonImg,
	IonToggle,
	createAnimation,
} from "@ionic/react";
import * as constants from "../../../constants";
import "./cart.scss";
import "../../../global.scss";
import "../Confirmation/confirm.scss";
import moment from "moment";
import {
	getCartItemsList,
	deleteCartItemList,
	fetchCartItem,
	deleteCartItem,
	uploadCartImage,
	applyOfferCode,
	getOffersData,
	// getMultiServiceData,
	deleteCartImage,
	updateCartItem,
	insertCartImagesIntoCartItems,
	deleteImagesFromCartImages,
	clearBookingImages,
} from "../../../Store/Actions";
import { connect } from "react-redux";
import PageHeading from "../../CustomComponents/PageHeading";
import { ToastMessage } from "../../../utils/toastMessage";
import ConfirmScreen from "../Confirmation/confirmation";
import { Camera, CameraOptions } from "@ionic-native/camera";
import AddOnModal from "../../../utils/addOnModal";
import { AlertMessage } from "../../../utils/alertMessage";
import { CustomIonImage } from "../../CustomComponents/IonImg";
import { checkMediaQuery } from "../../../utils";
import LoginInCart from "./loginInCart";
import OtpInCart from "./otpInCart";
import { COLLECTIONS, updateDoc } from "../../../firebase";

const options: CameraOptions = {
	destinationType: Camera.DestinationType.DATA_URL,
	sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM,
	encodingType: Camera.EncodingType.JPEG,
};

export const leaveAnimation = (baseEl: any) => {
	const backdropAnimation = createAnimation()
		.addElement(baseEl.querySelector("ion-backdrop")!)
		.fromTo("transform", "translateX(0px)", "translateX(400px)")
		.fromTo("opacity", "1", "1");

	const wrapperAnimation = createAnimation()
		.addElement(baseEl.querySelector(".modal-wrapper")!)
		.fromTo("transform", "translateX(0px)", "translateX(400px)")
		.fromTo("opacity", "1", "1");

	return createAnimation()
		.addElement(baseEl)
		.easing("ease-out")
		.duration(500)
		.addAnimation([wrapperAnimation]);
};

const Cart: React.FC = (props: any) => {
	const [state, setState] = React.useState<any>({
		items: [],
		estimate: {},
	});
	const [customizeService, setCustomizeService] = React.useState<any>(false);
	const [applyPromoCode, setApplyPromoCode] = React.useState<any>(false);
	const [offerCode, setOfferCode] = React.useState<string>("");
	const [showConfirm, setShowConfirm] = React.useState<Boolean>(false);
	const [selectedAddons, setSelectedAddons] = useState<any>([]);
	const [oilGrade, setOilGrade] = useState<any>({});
	const [addOnSections, setAddOnSections] = useState([]);
	const [alert, showAlert] = useState(false);
	const [deleteItemId, setDeleteItemId] = useState("");
	const [imagesModal, openImagesModal] = useState(false);
	const [login, setLogin] = useState(false);
	const [showOtp, setShowOtp] = useState(false);
	const [images, setImages] = useState<any>({
		images: null,
		cartId: "",
	});
	const [serviceTotal, setServiceTotal] = useState(0);

	React.useEffect(() => {
		// console.log("Cart >> props.service_data ..... ", props);
		if (props.service_data.length === 0) {
			props.applyOfferCode({ offerCode: "" });
			const userDoc = {
				settings: { ...props.settings, workshopId: "" },
			};
			updateDoc(props.uid, userDoc, COLLECTIONS.USERS);
		}
	}, [props.service_data]);

	const deleteItem = async (id: string) => {
		setDeleteItemId(id);
		showAlert(true);
	};

	const clearCart = () => {
		props.deleteCartItemList();
		props.getCartItemsList();
	};

	const [toast, setToast] = useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});

	const addToCart = async () => {
		try {
			const cartItem = props.service_data.find(
				(ele: any) => ele.cartItemId === images.cartId
			);
			const payload = {
				...cartItem,
				addOnsSelected:
					selectedAddons.length || Object.keys(oilGrade).length
						? [...selectedAddons, oilGrade]
						: [],
			};
			await props.updateCartItem(cartItem.cartItemId, payload);
			props.insertCartImagesIntoCartItems([...images.images], cartItem.cartItemId);
		} catch (e: any) {
			setToast({
				showToast: true,
				toastMessage: e.message,
				severity: "warning",
			});
		}
	};

	const handleUploadImage = async (event: any, id: string) => {
		try {
			const file = event.target.files[0];
			if (["image/png", "image/jpg", "image/jpeg"].includes(file.type)) {
				event.preventDefault();
				const fd = new FormData();
				const base64Image: any = await toBase64(event.target.files[0]);
				const convertedFIle: any = await imageConversion(base64Image, id);
				fd.append("file", convertedFIle);
				const res = await props.uploadCartImage(id, fd);
				if (imagesModal && !!res) {
					setImages({
						...images,
						images: [...images.images, res.data[0].message],
					});
					props.insertCartImagesIntoCartItems(
						[...images.images, res.data[0].message],
						res.data[0].id
					);
				}
				return res;
			} else {
				setToast({
					showToast: true,
					toastMessage: ".PNG, .JPEG, .JPG are allowed",
					severity: "warning",
				});
			}
		} catch (error: any) {
			console.error(error);
		}
	};

	const toBase64 = (file: any) =>
		new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = (error) => reject(error);
		});

	const imageConversion = (imageData: any, id: string) => {
		return fetch(imageData)
			.then((res) => res.blob())
			.then(async (blob) => {
				const b: any = blob;
				b.lastModifedDate = new Date();
				b.name = "testimg.jpeg";
				const file = new File([b], "image.png", { type: "image/png" });
				return file;
			});
	};

	const AccessNativeCamera = async (id: any) => {
		Camera.getPicture(options).then(
			async (imageData) => {
				const file = await imageConversion("data:image/jpeg;base64," + imageData, id);
				const formData = new FormData();
				formData.append("file", file.name[0]);
				const res = await props.uploadCartImage(id, formData);
				if (imagesModal && !!res) {
					setImages({
						...images,
						images: [...images.images, res.data[0].message],
					});
					props.insertCartImagesIntoCartItems(
						[...images.images, res.data[0].message],
						res.data[0].id
					);
				}
			},
			(err: any) => {
				console.error(err, "CamError");
			}
		);
	};

	const Apply = async (off_code?: string) => {
		try {
			const { offersData } = props;
			const offerData = offersData.find(
				(ele: any) => ele.offerCode === (offerCode || off_code)
			);
			if (!offerData) {
				throw Error("Please enter valid offer code");
			}
			if (new Date(offerData.validity.endDate) < new Date()) {
				throw Error("Code Expired");
			}
			if (offersData.find((ele: any) => ele.offerCode === (offerCode || off_code))) {
				await props.applyOfferCode({ offerCode: offerCode || off_code });
				await props.getCartItemsList();
				await setApplyPromoCode(false);
			}
		} catch (e: any) {
			setToast({
				toastMessage: e.message,
				showToast: true,
				severity: "warning",
			});
		}
	};

	const removeCoupon = async () => {
		await props.applyOfferCode({ offerCode: "" });
		await props.getCartItemsList();
	};

	const handleKeypress = (e: any) => {
		if (e.key === "Enter") {
			Apply();
		}
	};

	const closeModal = () => {
		setShowConfirm(false);
		props.clearBookingImages();
	};

	//Animation

	const enterAnimation = (baseEl: any) => {
		return leaveAnimation(baseEl).direction("reverse");
	};

	const setAddOnsModal = async (service_data: any, addOns: any) => {
		await setAddOnSections(service_data);
		addOns.map((addOn: any) => {
			service_data.map(async (ele: any) => {
				if (ele.selectionType === "Multiple") {
					var checkbox = ele.items.find((item: any) => item.addOnId === addOn.addOnId);
					if (!!checkbox) {
						await setSelectedAddons((state: any) => [...state, checkbox]);
					}
				} else {
					var radio = ele.items.find((item: any) => item.addOnId === addOn.addOnId);
					if (!!radio) {
						await setOilGrade(radio);
					}
				}
			});
		});
		setCustomizeService(true);
	};
	const CouponsCard = (ele: any, index: any) => {
		return (
			<div
				className={ele.expiredCoupon ? "cart_layout expired_card" : "cart_layout"}
				key={index}
				// onClick={() => setOfferCode(ele.offerCode)}
			>
				<IonRow
					className="cart_discount_row"
					onClick={async () => {
						setOfferCode(ele.offerCode);
						Apply(ele.offerCode);
					}}
				>
					{!!ele.name && (
						<>
							<IonCol className="vocher_code" size-md="6" size="7">
								<div className="discount_div">
									<IonLabel className="discount_percentage" color="secondary">
										{ele.name.split(" ").map((name: any, index: any) => (
											<IonLabel
												className={
													index === 1
														? "discount_value_offers_cart"
														: "discount_percentage_offers_cart"
												}
												key={index}
												color="secondary"
											>
												{index === 2 ? "Discount" : name}
											</IonLabel>
										))}
									</IonLabel>
								</div>
								<div className="border_code">
									<IonLabel className="year">
										{constants.USE_CODE}
										<span className="offercode_font">{ele.offerCode}</span>
									</IonLabel>
								</div>
								<IonLabel className="discount_date">
									{constants.VALID}
									<span className="date">
										{moment(new Date(ele.validity.endDate)).format("DD MMM YYYY")}
									</span>
								</IonLabel>
							</IonCol>
							<IonCol className="image_panel" size-md="6" size="5">
								<div className="img_scroll">
									<img
										src={ele.imageUrl}
										// src="/images/offer_icon.svg"
										className="cart_discount_slides"
									/>
								</div>
							</IonCol>
						</>
					)}

					{!ele.name && (
						<IonCol className="image_panel" size-md="12" size="12">
							<div className="img_scroll">
								<IonImg src={ele.imageUrl} />
							</div>
						</IonCol>
					)}
				</IonRow>
			</div>
		);
	};
	const couponData = !!props.offersData && props.offersData;
	const available_coupouns =
		!!couponData &&
		couponData.filter(
			(ele: any) =>
				moment(new Date()).format("MM/DD/YYYY") <=
				moment(new Date(ele.validity.endDate)).format("MM/DD/YYYY")
		);
	const expired =
		!!couponData &&
		couponData.filter(
			(ele: any) =>
				moment(new Date()).format("MM/DD/YYYY") >
				moment(new Date(ele.validity.endDate)).format("MM/DD/YYYY")
		);

	React.useEffect(() => {
		const _service_total = (props.service_data || []).reduce((acc: any, cur: any) => {
			return acc + Number(cur.defaultPrice);
		}, 0);
		setServiceTotal(_service_total);
	}, [props.service_data]);

	return (
		<>
			<IonCol
				className={
					!!props.service_data.length
						? "res_bg_color cart_res fixed_panel pd_0"
						: "res_bg_color cart_res fixed_panel pd_0 empty_grid"
				}
			>
				<div className="cart_body">
					<PageHeading mainHeader="My Cart" navigation={props} />
				</div>
				{!!props.service_data.length ? (
					<>
						<div
							className={
								isPlatform("ios") ? "body_scroll bodyscrool_top25" : "body_scroll"
							}
						>
							{(props.service_data || []).map((ele: any, ind: number) => (
								<div className="brake_problem" key={ind}>
									<img
										src={!!ele.imageUrl ? ele.imageUrl : "/images/brake_image.svg"}
										className="rec_ser_image"
										style={{ marginRight: 10 }}
									/>
									<div className="brake_row_wrap">
										<div
											style={{
												// width: "96%",
												display: "flex",
												justifyContent: "space-between",
											}}
										>
											<div className="brake_row_child">
												<IonLabel className="brake_text">
													{ele.partDisplayName || ele.displayName}
												</IonLabel>
												<IonLabel className="repair">{ele.shortDescription}</IonLabel>
											</div>
											<div onClick={() => deleteItem(ele.cartItemId)}>
												<img
													src="/images/brake_delete_icon.svg"
													className="delete-cart-item-icon"
													style={{ marginRight: 5 }}
												/>
											</div>
										</div>
										<div
											style={{
												marginTop: !!ele.shortDescription ? "5px" : "20px",
											}}
											className={
												// !!(ele.addOnSections || []).length
												!!ele.addOnSections && !!ele.addOnSections.length
													? "customize_div"
													: "customize_div float_right"
											}
										>
											{Boolean(ele.addOnSections.length) &&
												(!!ele.addOnsSelected &&
												ele.addOnsSelected.length &&
												ele.addOnsSelected.some((x: any) => !!x.addOnId) ? (
													<div
														style={{
															display: "flex",
															alignItems: "center",
														}}
													>
														<IonLabel className="addon-details">Add on : </IonLabel>
														<IonButton
															color="addon"
															className="customize_btn"
															onClick={() => {
																if (ele.addOnSections.length) {
																	setAddOnsModal(ele.addOnSections, ele.addOnsSelected);
																	setImages({
																		images: ele.images,
																		cartId: ele.cartItemId,
																	});
																}
															}}
														>
															<IonLabel
																className="truncate_add_ons"
																title={ele.addOnsSelected
																	.map((ele: any) => ele.displayName)
																	.slice(0, 1)
																	.join(",")}
															>
																{ele.addOnsSelected
																	.map((ele: any) => ele.displayName)
																	.slice(0, 1)
																	.join(",")}
															</IonLabel>
															<img
																className="down_arrow"
																src="/images/customize_down_icon.svg"
															/>
														</IonButton>
													</div>
												) : (
													<IonButton
														color="addon"
														className="customize_btn"
														onClick={() => {
															if (ele.addOnSections.length) {
																setAddOnsModal(ele.addOnSections, ele.addOnsSelected);
																setImages({
																	images: ele.images,
																	cartId: ele.cartItemId,
																});
															}
														}}
													>
														<IonLabel className="customize_text">
															{constants.CUSTOMIZE}
														</IonLabel>
														<img
															className="down_arrow"
															src="/images/customize_down_icon.svg"
														/>
													</IonButton>
												))}
											<div
												style={{
													position: "relative",
												}}
												onClick={(event: any) => {
													if (isPlatform("mobile") || isPlatform("mobileweb")) {
														return !!ele.images && ele.images.length
															? null
															: AccessNativeCamera(ele.cartItemId);
													}
												}}
											>
												<IonLabel
													className="add_images confirm_add_img"
													onClick={() => {
														if (!!ele.images && ele.images.length) {
															setImages({
																images: ele.images,
																cartId: ele.cartItemId,
															});
															openImagesModal(true);
														}
													}}
												>
													{!!ele.images && ele.images.length
														? constants.IMAGES_ADDED
														: constants.ADD_IMAGES}
												</IonLabel>
												{!!ele.images && ele.images.length
													? null
													: (isPlatform("desktop") || isPlatform("mobileweb")) && (
															<input
																type="file"
																className="input_type_file_cart_image"
																accept=".png , .jpg, .jpeg"
																onChange={(event) => {
																	handleUploadImage(event, ele.cartItemId);
																}}
															/>
													  )}
											</div>
										</div>
									</div>
								</div>
							))}
							<div
								className="add_more_service cursor_pointer_style"
								onClick={() => props.history.push("/portal/book_service")}
							>
								<IonLabel className="add_text">{constants.ADD_MORE_SERVICES}</IonLabel>
								<img src="images/add-service.svg" className="add_services" />
							</div>
							<div
								className="apply_coupon"
								onClick={() => !props.offer_code && setApplyPromoCode(true)}
							>
								<div className="apply_coupon_right">
									<img className="coupon" src="/images/save_per.svg" />
									<IonLabel className="apply_coupon_text">
										{!!props.offer_code ? props.offer_code : constants.APPLY_COUPON}
									</IonLabel>
								</div>
								{!!props.offer_code ? (
									<img src="/images/close_popup.svg" onClick={() => removeCoupon()} />
								) : (
									<img className="right_arrow" src="/images/left_arrow_gray.svg" />
								)}
							</div>
							{Boolean(Object.keys(props.cart_estimates).length) && (
								<div className="bill_details">
									<IonLabel className="bill_text">
										{constants.BILL_DETAILS}{" "}
										<div className="services_text">
											({props.service_data.length}
											{constants.TWO_SERVICES}
											{props.service_data.length > 1 ? "s" : ""})
										</div>
									</IonLabel>
									<div className="service_total">
										<IonLabel className="service_total_text">
											{constants.SERVICE_TOTAL} ({constants.EXCL_TAXES})
										</IonLabel>
										<IonLabel className="amount">
											{constants.RupeeSymbol} {props.cart_estimates.totalEstimated}
										</IonLabel>
									</div>
									<div className="service_total">
										<IonLabel className="service_total_text">
											{constants.COUPON_DISCOUNT}
										</IonLabel>
										<IonLabel
											className="apply_coupon_text"
											onClick={() => {
												if (!props.offer_code) {
													setApplyPromoCode(true);
												}
											}}
										>
											{!!props.offer_code
												? `${"-"} ${constants.RupeeSymbol} ${
														props.cart_estimates.discount
												  }`
												: constants.APPLY_COUPON}
										</IonLabel>
									</div>
									<div className="service_total">
										<IonLabel className="service_total_text">
											{constants.TOTAL_ESTIMATED}
										</IonLabel>
										<IonLabel className="amount">
											{constants.RupeeSymbol}{" "}
											{Number(props.cart_estimates.totalEstimated) -
												Number(props.cart_estimates.discount)}
										</IonLabel>
									</div>
								</div>
							)}
							{!!props.offer_code ? (
								<div className="refer_your_friends">
									<img className="refer_icon" src="/images/applied_coupon.svg" />
									<IonLabel className="refer_frnds_text">
										{constants.APPLIED_COUPON}
									</IonLabel>
								</div>
							) : (
								<div className="refer_your_friends">
									<img className="refer_icon" src="/images/refer-icon.svg" />
									<IonLabel className="refer_frnds_text">
										{constants.REFER_YOUR_FRIENDS}
									</IonLabel>
								</div>
							)}
						</div>
						<div className="page-footer footer_fixed cart-amount-details">
							<div className="cart-pricing-segment-details">
								<IonLabel className="sd_pricing_text">
									{constants.PRICE_BASED_ON}
									{" " +
										(props.settings.pricingSegment || "").charAt(0).toUpperCase() +
										(props.settings.pricingSegment || "").slice(1) +
										" "}
									{constants.PRICING}
								</IonLabel>
							</div>
							<div className="cart-cost-details">
								<div className="sd_col">
									<IonLabel className="sd_escost">{constants.ESTIMATED_COST}</IonLabel>
									<IonLabel className="sd_price cart_sd_price ">
										{constants.RupeeSymbol}{" "}
										{Number(props.cart_estimates.totalEstimated) -
											Number(props.cart_estimates.discount)}
									</IonLabel>
								</div>
								<IonButton
									color="light"
									className="btn_width_153"
									onClick={() => {
										// console.log("props.workshopId == ", props.workshopId);
										if (!!props.workshopId === true) {
											setShowConfirm(true);
										} else {
											// console.log("props.workshopId ==  eeeeee == ", props.workshopId);
											setToast({
												showToast: true,
												toastMessage: "Select Workshop to continue",
												severity: "warning",
											});
										}
									}}
								>
									<IonLabel color="primary" className="button-label">
										{constants.BOOK_NOW}
									</IonLabel>
								</IonButton>
							</div>
						</div>
						<IonModal
							isOpen={!!showConfirm}
							backdropDismiss={true}
							onDidDismiss={() => closeModal()}
							cssClass="confirmModal"
							animated={checkMediaQuery() ? false : true}
							enterAnimation={enterAnimation}
							leaveAnimation={leaveAnimation}
						>
							<ConfirmScreen
								{...props}
								showModal={!!showConfirm}
								closeModal={closeModal}
							/>
						</IonModal>
						{/* <IonModal
              isOpen={login}
              backdropDismiss={true}
              onDidDismiss={() => setLogin(false)}
              cssClass="confirmModal"
              animated={checkMediaQuery() ? false : true}
              enterAnimation={enterAnimation}
              leaveAnimation={leaveAnimation}
            >
              {!showOtp ? (
                <LoginInCart {...props} showOtp={() => setShowOtp(true)} />
              ) : (
                <OtpInCart {...props} />
              )}
            </IonModal> */}
					</>
				) : (
					<div>
						<div className="cartItem">
							<img
								className={checkMediaQuery() ? "cart_img cart_marginRight30" : "cart_img"}
								src="/images/empty-cart.svg"
								alt="cart"
							/>
							<IonLabel
								className={
									checkMediaQuery() ? "cart-text cart_text_mrgnLeft0" : "cart-text"
								}
								color="secondary"
							>
								{constants.EMPTY_CART}
							</IonLabel>
						</div>
						<div
							className="btn_parent_div bt_left_40"
							style={{
								marginRight: checkMediaQuery() ? 25 : 0,
								marginLeft: checkMediaQuery() ? 25 : 40,
								width: "-webkit-fill-available",
							}}
						>
							<IonButton
								// onClick={() => setScreenName("AddVehicle")}
								onClick={() => props.history.push("/portal/book_service")}
								color="primary"
								className="continue_btn child_btn"
								expand="block"
								style={{
									marginBottom: 30,
									minWidth: "auto",
									width: "100%",
									maxWidth: checkMediaQuery() ? "none" : 320,
								}}
							>
								{constants.BOOK_A_SERVICE}
							</IonButton>
						</div>
						<p className="service_text">{constants.BEST_CAR_SERVICE}</p>
					</div>
				)}
				<AddOnModal
					restoreState={() => {
						setSelectedAddons([]);
						setOilGrade({});
						setAddOnSections([]);
					}}
					showAddon={customizeService}
					oilGrade={oilGrade}
					selectedAddons={selectedAddons}
					setShowAddon={(value: boolean) => setCustomizeService(value)}
					addOnSections={addOnSections}
					setOilGrade={(value: any) => {
						if (value.addOnId !== oilGrade.addOnId) {
							setOilGrade(value);
						} else {
							setOilGrade({});
						}
					}}
					setSelectedAddons={(value: any) => {
						const index = selectedAddons.findIndex(
							(ele: any) => ele.addOnId === value.addOnId
						);
						if (index < 0) {
							setSelectedAddons([...selectedAddons, value]);
						} else {
							setSelectedAddons(
								selectedAddons.filter((ele: any) => ele.addOnId !== value.addOnId)
							);
						}
					}}
					submitData={() => {
						setCustomizeService(false);
						addToCart();
						setImages({
							images: null,
							cartId: "",
						});
					}}
				/>
				<AlertMessage
					showAlert={alert}
					alertMessage={"Are you sure you want to delete the item from cart?"}
					onDidDismiss={() => {
						setDeleteItemId("");
						showAlert(false);
					}}
					alertHeader={"Delete Item from cart"}
					actionItemForAlert={async () => {
						localStorage.removeItem("workshopId");
						await props.deleteCartItem(deleteItemId);
						await props.getCartItemsList();
						setDeleteItemId("");
						showAlert(false);
					}}
				/>
				<ToastMessage
					showToast={toast.showToast}
					ToastMessage={toast.toastMessage}
					severity={toast.severity}
					onDidDismiss={() => {
						setToast({
							showToast: false,
							toastMessage: "",
							severity: "",
						});
					}}
				/>
				<IonModal
					cssClass="cart-web-pop"
					isOpen={applyPromoCode}
					backdropDismiss={true}
					onDidDismiss={() => {
						setOfferCode("");
						setApplyPromoCode(false);
					}}
				>
					<div className="modal_body model_container">
						<div className="modal_panel customize_panel model_header  web-header bg_color_promo">
							<IonText className="modal_header vehicle_header ">
								{constants.APPLY_PROMO_CODE}
							</IonText>
							<img
								className="close_icon"
								onClick={() => setApplyPromoCode(false)}
								src="/images/close_popup.svg"
							/>
						</div>
						<div className="promo_code_parent">
							<div className="apply_input_div">
								<IonInput
									className="apply_promo_code"
									type="text"
									placeholder={constants.ENTER_COUPON_CODE}
									value={offerCode}
									onIonChange={(e: any) => setOfferCode(e.detail.value)}
									onKeyPress={(e: any) => handleKeypress(e)}
								/>
								<div className="apply_btn_text" onClick={() => Apply()}>
									{constants.APPLY}
								</div>
							</div>

							{available_coupouns.length > 0 && (
								<div className="available_coupons">
									<IonLabel>{constants.AVAILABLE_COUPONS}</IonLabel>
								</div>
							)}

							{available_coupouns.length > 0 &&
								available_coupouns.map((ele: any, ind: number) => (
									<CouponsCard {...ele} key={ind} />
								))}

							{expired.length > 0 && (
								<div className="available_coupons">
									<IonLabel>{constants.EXPIRED_COUPONS}</IonLabel>
								</div>
							)}

							{expired.length > 0 &&
								expired.map((ele: any, ind: number) => (
									<CouponsCard expiredCoupon={expired.length > 0} {...ele} key={ind} />
								))}
						</div>
					</div>
				</IonModal>
				<IonModal
					isOpen={imagesModal}
					backdropDismiss={true}
					cssClass="cart-web-pop"
					onDidDismiss={() => {
						openImagesModal(false);
						setImages({
							images: null,
							cartId: "",
						});
					}}
				>
					<div className="modal_panel customize_panel model_header web-header cart_img_add">
						<IonLabel className="modal_header vehicle_header bold_text">
							{constants.IMAGES}
						</IonLabel>
						<img
							onClick={() => {
								openImagesModal(false);
								setImages({
									images: null,
									cartId: "",
								});
							}}
							src="/images/close_popup.svg"
							className="close_icon"
						/>
					</div>
					{!!images.images && (
						<div className="upload-cart-images justify_flexstart">
							{images.images.map((img: any, index: any) => (
								<div className="upload-rc-documents mrgnRight5" key={img}>
									<CustomIonImage imgpath={img} key={img} />
									{/* <img
                    src={"/images/close-icon.svg"}
                    alt=""
                    style={{
                      height: "100%",
                    }}
                  /> */}
									<img
										src={"/images/close-icon.svg"}
										className="document-remove-icon"
										onClick={() => {
											props.deleteCartImage(images.cartId, {
												url: img,
											});
											props.deleteImagesFromCartImages(
												images.images.filter(
													(ele: any) => ele.split("/").pop() !== img.split("/").pop()
												),
												images.cartId
											);
											setImages({
												...images,
												images: images.images.filter(
													(ele: any) => ele.split("/").pop() !== img.split("/").pop()
												),
											});
										}}
									/>
								</div>
							))}
							<div className="upload-rc-documents">
								<div
									onClick={(event: any) => {
										if (isPlatform("mobile") || isPlatform("mobileweb")) {
											AccessNativeCamera(images.cartId);
										}
									}}
								>
									<img src={"/images/add.svg"} />
									{(isPlatform("desktop") || isPlatform("mobileweb")) && (
										<input
											type="file"
											className="input_type_file_cart_image"
											accept=".png , .jpg, .jpeg"
											onChange={async (event) => {
												await handleUploadImage(event, images.cartId);
											}}
										/>
									)}
								</div>
							</div>
						</div>
					)}
				</IonModal>
			</IonCol>
		</>
	);
};
export default connect(
	({
		auth,
		cart: { cart_items, cart_estimates, offer_code, service_data, service_data_value },
		dashboard: { offersData },
	}: any) => ({
		...auth,
		cart_items,
		cart_estimates,
		offer_code,
		offersData,
		service_data,
		service_data_value,
	}),
	{
		getCartItemsList,
		deleteCartItemList,
		fetchCartItem,
		deleteCartItem,
		uploadCartImage,
		applyOfferCode,
		getOffersData,
		// getMultiServiceData,
		deleteCartImage,
		updateCartItem,
		insertCartImagesIntoCartItems,
		deleteImagesFromCartImages,
		clearBookingImages,
	}
)(Cart);
